import React from 'react'
import startOnSiteApp from '@purecarslabs/signal-core/baseline/on-site-app'
import { OnSiteAppComponentPropsType } from '@signal/core/baseline/on-site-app/types'
/* webpack-strip-block:removed */
import ApiContainer from '@app-src/containers/ApiContainer'
import { FORM_INJECT_ANCHOR_CLASSNAME } from './constants'

/**
 * THIS IS THE ENTRY POINT FOR THE MAIN APP BUNDLE - bundle.js
 */
export const bootApp = (
  skipMount = false
): React.FC<OnSiteAppComponentPropsType> => {
  return startOnSiteApp({
    appName: 'Lead Forms App App',
    injectSelector: `.${FORM_INJECT_ANCHOR_CLASSNAME}`,
    skipMount,
    OnSiteComponent: ApiContainer
  })
}

/* webpack-strip-block:removed */
  bootApp()
  /* webpack-strip-block:removed */
